export default __webpack_public_path__ + "static/media/renew-contract-button.3ebfcce5.png";